/*
    Controller to launch the dialog used to create a production devicegroup.
    This is a "mission control" level action.
    The dialog allows the user to input a name for the to-be-created production devicegroup,
    as well as select what code will run on this devicegroup's devices from a list of promoted
    deployments (flagged=true).
    Usage: 
        var globalCh = Radio.channel('global');
        globalCh.request('show_create_production_devicegroup', {{product}});
    Arguments:
        product: Instance of v5 "product" model public/js/models/v5/product.js against which you want
            to create a new production devicegroup.
*/

import Radio from 'backbone.radio';
import ProductionDevicegroupDialog from '@/views/dialogs/production_device_group_settings';
import PaginationControls from '@/views/pagination_controls';

    export default function show_create_production_devicegroup(product) {
        var globalCh = Radio.channel('global');
        var apiCh = Radio.channel('api');
        var deployments = apiCh.request('deployment');
        var pagination_controls = new PaginationControls({
            collection: deployments
        });
        var production_devicegroup_dialog = new ProductionDevicegroupDialog({
            pagination_controls: pagination_controls,
            product: product,
            deployments: deployments,
            type: 'pre_production_devicegroup'
        });
        deployments.fetch({
            remove: false,
            data: {
                'filter[product.id]': product.id,
                'filter[devicegroup.type]': 'development_devicegroup,pre_production_devicegroup'
            },
        })
        .done(pagination_controls.update_prev_next_from_response)
        .then(function(){
            globalCh.request('showDialog', production_devicegroup_dialog);
        });
        
    }
